import {Mapper} from '@s-ui/domain'

export class FromVehicleInfoValueObjectToVehicleInfoWithCompetitorsValueObjectMapper extends Mapper {
  constructor({vehicleInfoValueObjectFactory}) {
    super()
    this._vehicleInfoValueObjectFactory = vehicleInfoValueObjectFactory
  }

  map = ({vehicleInfoValueObject, competitorsValueObject}) => {
    const {vehicleInfo} = vehicleInfoValueObject.toJSON()
    const relatedVehicles = competitorsValueObject.getItems()
    return this._vehicleInfoValueObjectFactory({
      vehicleInfo: {
        ...vehicleInfo,
        relatedVehicles
      }
    })
  }
}
